module.exports = __webpack_public_path__ + "img/pipe-5.67473baf.jpg";